import { render, staticRenderFns } from "./CategoryPopup.vue?vue&type=template&id=6ecdae6c&"
import script from "./CategoryPopup.vue?vue&type=script&lang=js&"
export * from "./CategoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports